export const coreAddresses = {
  balanceTracker: "0x2D13C46FE6c8B6c9ad3C5A78eD51b26733caE350",
  eVaultFactory: "0x7F53E2755eB3c43824E162F7F6F087832B9C9Df6",
  eVaultImplementation: "0xB236413f1A8Fd4C5D5545ecAaC5e64fF686afe4e",
  eulerEarnFactory: "0xc456d04E3F43597CC7E5a2AF284fF4C4AdDA0cb1",
  evc: "0xb2E5a73CeE08593d1a076a2AE7A6e02925a640ea",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0xF524F75ad063919B86d6c5D9242847A44337BFCe",
  sequenceRegistry: "0x7fD287B3AE3Bf2F6C9871a44b6d9de208B0ABBE5",
} as const
